import { z } from 'zod';

export const CoreIntegrationEsriLayerSettingScalarFieldEnumSchema = z.enum(['id','cityId','userId','createdAt','startedAt','name','urlPath','syncFrequency','afterCopy','fields','CoreIntegrationEsriSettingId','CoreImportDefinitionId','lastSyncAt']);

export default CoreIntegrationEsriLayerSettingScalarFieldEnumSchema;
